import { Component } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import moment from 'moment';
import { formatear, periodosOperativo } from '../../funciones/funcionesGenerales';
import { FiltersM } from '../../../components/models';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import Swal from 'sweetalert2';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);
import { generatePDF } from '../../funciones/makePdf';

@Component({
  selector: 'app-metas',
  templateUrl: './metas.component.html',
  styleUrl: './metas.component.css'
})
export class MetasComponent {
  private pdfFile: any;

  Filters = FiltersM;
  // Variables para los filtros
  sucursales = [];
  consolidado = true;
  periodos = [];
  month = 'Enero';
  perspective1 = 'Adultos';
  perspective2 = 'Menores';
  encabezados = ["","","","","","","","",""]
  
  dataTable = [];

  //Tarjetas
  tarjets = [];
  constructor(
    public dataService: DataService,
    private readonly translate: TranslateService,
  ){
    formatear.momentAbrev();
    this.getPeriods();
  }

  private getPeriods(){
    for(var i = 0; i<10; i++){
      this.sucursales.push({
        name: `Sucursal-${i+1}`,
        check: false
      });
    }

    const start = moment('2023-05-01');
    const end = moment();
    var auxYear = [], auxMounts = [], year = undefined;
    while(start.isSameOrBefore(end)){
      if(year !== undefined && year !== start.year()){
        auxYear[auxYear.length-1].series = auxMounts;
        auxMounts = [];
      }
      const exYear = auxYear.find(y => y.anio === start.year());
      if(!exYear){
        year = start.year();
        auxYear.push({
          anio: start.year(),
          series: [],
          visible: true,
          utilizable: true,
        });
      }
      auxMounts.push({
        mes: start.format('MMM').toLowerCase(),
        mesS: start.format('MMMM').toLowerCase(),
        check: false,
        an: start.year(),
        anio: start.format('YY'),
        periodo: start.format('MMM-YY').toLowerCase(),
        visible: true,
        utilizable: true,
      });
      start.add(1, 'month');
    }
    auxYear[auxYear.length-1].series = auxMounts;

    this.periodos = auxYear;
    this.periodos[this.periodos.length-1].series[this.periodos[this.periodos.length-1].series.length-1].check = true;
    this.month = this.periodos[this.periodos.length-1].series[this.periodos[this.periodos.length-1].series.length-1].mesS;
    this.getData();
  }

  private getPeriodo(){
    var per;
    this.periodos.forEach(anio => {
      const encontrado = anio.series.find(mes => mes.check === true);
      if (encontrado) {
        per = encontrado.periodo;
      }
    });
    return per;
  }

  private getData(){
    const per = this.getPeriodo();
    this.dataTable = [];
    for(var i = 0; i<50; i++){
      var aux: { [key: string]: any } = {};
      this.encabezados.forEach( (enc, index) =>{
        if(index === 0){
          aux[`colum${index}`] = `S-${i+1}`
        }else{
          aux[`colum${index}`] = Number(( Math.random()* (100 - 15 + 1) + 15 ).toFixed(1));
        }
      });
      this.dataTable.push(aux);
    }
    this.tarjets = [];
    for(var i = 0; i<4; i++){
      this.tarjets.push({
        header: 'Encabezado '+(i+1),
        value: Number(( Math.random()* (150 - 15 + 1) + 15 ).toFixed(1)),
        footer: per,
        icon: 'face'
      });
    }
  }

  agencyChange(sucClick: any){
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    if(sucClick === 'consolidado'){
      this.consolidado = !this.consolidado;
    }else{
      this.consolidado = false;
    }
    this.getData();
  }

  yearChange(event){
    this.periodos.forEach( anio => {
      anio.series.forEach( per => {
        if(per.periodo === event.periodo){
          per.check = true;
          this.month = per.mesS;
        }else{
          per.check = false;
        }
      });
    });
    this.getData();
  }

  getBorderColor(data, col){
    if(data[`colum${col}`] > 80){
      return '#4CAF50';
    }else if(data[`colum${col}`] > 50){
      return '#ffeb3b';
    }else if(data[`colum${col}`] >= 0){
      return '#f44336';
    }
    return '';
  }

  //Exportación de PDF All
  async exportarPDF(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        pageOrientation: 'landscape',
        content: [
          await this.generateTablePDF(),
        ]
      }

      var reportName = 'Reporte general';
      const pdf = pdfMake.createPdf(docPDF);
      
      pdf.download(reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
    }catch(error){
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  private async generateTablePDF(){
    var headers = [];
    var data = [];

    const h1 = [
      {text: '', col: 1},
      {text: this.month, col: 6},
      {text: '', col: 2},
    ];
    const h2 = [
      {text: '', col: 1},
      {text: this.perspective1, col: 3},
      {text: this.perspective2, col: 3},
      {text: this.translate.instant('comercial.asosiatividad.metas.titulo-encabezado-1'), col: 2},
    ];
    const h3 = [
      ...this.encabezados.flatMap( (e, index) => { return { text: this.translate.instant('comercial.asosiatividad.metas.titulo-'+(index+1)+'-tabla'), col:1 } }),
    ];

    headers.push(h1,h2,h3);
    var data = [];
    for(const d of this.dataTable){
      data.push(
        this.encabezados.map( (e, i) => {
          return {
            text: `${d[`colum${i}`]}`,
            border_color: i === 3 || i === 6 || i === 7 || i === 8  ? [this.getBorderColor(d, i), '#d6d6d6', '#d6d6d6', '#d6d6d6']:['#d6d6d6', '#d6d6d6', '#d6d6d6', '#d6d6d6'],
            border: i === 3 || i === 6 || i === 7 || i === 8  ? [true, true, false, true]:undefined,
          }
        })
      )
    }

    const head = await generatePDF.titles(this.translate.instant('comercial.asosiatividad.metas.encabezado'),this.getPeriodo());
    const tab = await generatePDF.table(headers, data);
    return [head, tab];
  }
}
